import script from "./HomeServiceList.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeServiceList.vue?vue&type=script&setup=true&lang=js"

import "./HomeServiceList.vue?vue&type=style&index=0&id=49eff070&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49eff070"]])

export default __exports__